import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { TEAM } from "./data";

const Member = ({ m, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  return (
    <Reveal delay={i * 0.15} className={i === 1 ? "sm:mt-28" : ""}>
      <motion.article ref={ref} whileHover="hover" className="group" data-testid={`team-member-${m.id}`}>
        <div className="relative aspect-[3/4] overflow-hidden rounded-t-[999px] rounded-b-[1.75rem] bg-[#E6ECE4]">
          <motion.img src={m.photo} alt={m.name} loading="lazy" style={{ y, scale: 1.14 }} className="absolute inset-0 w-full h-full object-cover object-[50%_18%]" />
          <motion.div variants={{ hover: { opacity: 1 } }} initial={{ opacity: 0 }} transition={{ duration: 0.5 }}
            className="absolute inset-0 bg-[radial-gradient(circle_at_50%_25%,rgba(134,200,155,0.28),transparent_60%)]" />
          <span className="absolute bottom-5 left-5 f-mono text-xs tracking-[0.25em] uppercase rounded-full bg-[#FCFBF7]/85 backdrop-blur px-3 py-1.5 text-[#1B3B28]">0{i + 1} · {m.role}</span>
        </div>
        <h3 className="f-serif text-4xl text-[#1B3B28] mt-6" data-testid={`team-member-name-${m.id}`}>{m.name}</h3>
        <p className="text-[#526356] mt-3 leading-relaxed max-w-sm">{m.text}</p>
      </motion.article>
    </Reveal>
  );
};

export const Team = () => (
  <section id="team" className="relative py-28 sm:py-40 bg-[#FCFBF7]" data-testid="team-section">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
        <SectionHead
          eyebrow="Il team parodontale"
          lines={["Un piccolo team,", "una cura grande."]}
          intro="Nei percorsi parodontali il Dott. Nicola Mauro è affiancato da due professioniste che conoscono bene le paure dei pazienti e sanno come scioglierle, con gentilezza e pazienza."
          testid="team-heading"
        />
      </div>
      <div className="lg:col-span-7 lg:col-start-6 grid sm:grid-cols-2 gap-10 sm:gap-8">
        {TEAM.map((m, i) => <Member key={m.id} m={m} i={i} />)}
      </div>
    </div>
  </section>
);
